import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-settings',
  templateUrl: './alert-settings.component.html',
  styleUrls: ['./alert-settings.component.css']
})
export class AlertSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
